"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var platform_browser_1 = require("@angular/platform-browser");
var core_2 = require("@ngx-translate/core");
var jquery_1 = __importDefault(require("jquery"));
var moment_1 = __importDefault(require("moment"));
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var user_service_1 = require("../../../services/user.service");
var toaster_logger_service_1 = require("../../../core/toaster-logger.service");
var modules_1 = require("../../../constants/modules");
var text_message_service_1 = require("../../../services/text-message.service");
var locale_date_time_pipe_1 = require("../../../filters/locale-date-time.pipe");
var notification_message_interface_1 = require("../../../interfaces/notification-message.interface");
var constants_1 = require("../../../constants");
var notification_service_1 = require("../../../services/notification.service");
var authorization_service_1 = require("../../../services/authorization.service");
var TextActionComponent = /** @class */ (function () {
    function TextActionComponent(domSanitizer, userService, logger, notificationService, authorizationService, renderer, textMessageService, translateService, localeDateTimePipe, changeDetectorRef, document, eulaModalService) {
        var _this = this;
        this.domSanitizer = domSanitizer;
        this.userService = userService;
        this.logger = logger;
        this.notificationService = notificationService;
        this.authorizationService = authorizationService;
        this.renderer = renderer;
        this.textMessageService = textMessageService;
        this.translateService = translateService;
        this.localeDateTimePipe = localeDateTimePipe;
        this.changeDetectorRef = changeDetectorRef;
        this.document = document;
        this.eulaModalService = eulaModalService;
        this.storeTextingUnavailableTranslationKey = 'textMessageStoreTextingUnavailable';
        this.userTextingUnavailableTranslationKey = 'textMessageUserTextingUnavailable';
        this.employeeUserTextingUnavailableTranslationKey = 'textMessageEmployeeUserTextingUnavailable';
        this.cultureName = 'en-us';
        this.textModalSelector = '#textModal';
        this.noUserNumberModal = '#noUserNumberModal';
        this.filteredMessagesModified = false;
        this.modalClosedSubject = new rxjs_1.Subject();
        this.upgradeProosalLinkPlaceholder = '[Upgrade Proposal Link]';
        this.subscriptionAggregator = new rxjs_1.Subscription();
        this.authorizationKeys = constants_1.AuthorizationKeys;
        this.eulaStatusTypes = constants_1.EulaStatusTypes;
        this.nestedModalBackdropZindex = 1060;
        this.saleTypes = constants_1.SaleTypes;
        this.last6Months = 'Last6Mon';
        this.lastMonth = 'LastMon';
        this.lastYear = 'LastYear';
        this.allTexts = 'AllTexts';
        this.sales = 'text_sales';
        this.service = 'text_service';
        this.translationKeys = [
            this.last6Months,
            this.lastMonth,
            this.lastYear,
            this.allTexts,
            this.sales,
            this.service
        ];
        this.translations = {};
        this.textMessages = [];
        this.filteredMessages = [];
        this.dateRangeOptions = [];
        this.newTextMessageValue = '';
        this.timeSpanToDisplay = this.last6Months;
        this.modules = modules_1.Modules;
        this.isTextable = false;
        this.authorizedKeys = {};
        this.selectedType = this.authorizationKeys.SendTextSales;
        this.isShortcutButton = false;
        this.latestNotificationObservable = null;
        this.translateService.get(this.translationKeys)
            .subscribe(function (translations) {
            _this.translations = translations;
            _this.dateRangeOptions = [
                { value: _this.last6Months, text: _this.translations.Last6Mon },
                { value: _this.lastMonth, text: _this.translations.LastMon },
                { value: _this.lastYear, text: _this.translations.LastYear },
                { value: _this.allTexts, text: _this.translations.AllTexts },
            ];
        });
    }
    TextActionComponent.prototype.handleNotification = function (message) {
        var _this = this;
        if (message.eventType === notification_message_interface_1.EventType.engagement &&
            message.data && message.data.type === notification_message_interface_1.EngagementEventTypeEnum.textMessageReplied &&
            message.data.customerID && message.data.customerID === this.opportunity.customer.id) {
            var lastMessage = this.textMessages[this.textMessages.length - 1];
            var lastMessageId = (lastMessage) ? lastMessage.messageId : undefined;
            var obs = this.textMessageService.getHistoryByCustomerId(this.opportunity.customer.id, lastMessageId);
            // Concatenate all observables so that rapid fire notifications will queue up
            if (this.latestNotificationObservable) {
                this.latestNotificationObservable = rxjs_1.concat(obs);
            }
            else {
                this.latestNotificationObservable = obs;
            }
            var sub = this.latestNotificationObservable.subscribe(function (newMessages) {
                var messagesToBeAppended = [];
                // only add messages that we don't already have. We need to do this because there is a chance
                // we get duplicate pubnub notifications or multiple notifications that come quick enough before
                // the api call finishes
                var currentLastMessage = _this.textMessages[_this.textMessages.length - 1];
                var currentLastMessageId = (currentLastMessage) ? currentLastMessage.messageId : undefined;
                for (var index = 0; index < newMessages.length; index++) {
                    if (newMessages[index].messageId > currentLastMessageId) {
                        messagesToBeAppended.push(newMessages[index]);
                    }
                }
                var mappedMessages = _this.mapServiceResults(messagesToBeAppended);
                _this.textMessages = _this.textMessages.concat(mappedMessages);
                _this.filterMessages();
            });
            this.subscriptionAggregator.add(sub);
        }
    };
    TextActionComponent.prototype.ngOnInit = function () {
        this.authorizedKeys[this.authorizationKeys.SendTextSales] = this.authorizationService.isAuthorized(this.authorizationKeys.SendTextSales);
        this.authorizedKeys[this.authorizationKeys.SendTextService] = this.authorizationService.isAuthorized(this.authorizationKeys.SendTextService);
        // Default the initial selection. If they have both permisions they go to sales
        if (this.authorizedKeys[this.authorizationKeys.SendTextService]) {
            this.selectedType = this.authorizationKeys.SendTextService;
        }
        if (this.authorizedKeys[this.authorizationKeys.SendTextSales]) {
            this.selectedType = this.authorizationKeys.SendTextSales;
        }
    };
    TextActionComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if ((changes.isCustomerConnectOpen || changes.isTextingEnabled) && this.isCustomerConnectOpen && this.isTextingEnabled) {
            this.refreshTextableStatus();
            this.userService.getUserProfile()
                .then(function (userProfile) {
                _this.cultureName = userProfile.cultureName ? userProfile.cultureName : 'en-us';
                _this.cultureName = _this.cultureName.toLowerCase();
                _this.userProfile = userProfile;
            });
            var translatedLinkText = this.translateService.instant('upgradeProposalLinkPlaceholder');
            this.upgradeProosalLinkPlaceholder = "[" + translatedLinkText + "]";
        }
        if (changes.opportunity && changes.opportunity.firstChange) {
            this.refreshTextableStatus();
        }
    };
    TextActionComponent.prototype.ngOnDestroy = function () {
        //$(this.textModalSelector).remove();
        jquery_1.default(this.noUserNumberModal).remove();
        this.subscriptionAggregator.unsubscribe();
    };
    TextActionComponent.prototype.ngAfterViewChecked = function () {
        if (this.filteredMessagesModified &&
            this.modalBodyElement.nativeElement.scrollTop !== this.modalBodyElement.nativeElement.scrollHeight) {
            // Scroll the modal body to the bottom
            this.renderer.setProperty(this.modalBodyElement.nativeElement, 'scrollTop', this.modalBodyElement.nativeElement.scrollHeight);
            this.filteredMessagesModified = false;
        }
    };
    TextActionComponent.prototype.getSanitizedAvatar = function (message) {
        if (!message) {
            throw new Error('No message passed to getSanitizedAvatar');
        }
        return (message.userAvatarUrl) ? this.domSanitizer.bypassSecurityTrustStyle('url(' + message.userAvatarUrl + ')') : '';
    };
    TextActionComponent.prototype.insertUpgradeProposalLink = function () {
        if (!this.authorizedKeys[this.selectedType]) {
            return;
        }
        // The trailing space after the placeholder is important so that we can easily find the link in the future and replace it with a anchor tag
        // don't remove it
        this.newTextMessageValue = this.newTextMessageValue + " " + this.upgradeProosalLinkPlaceholder + " ";
    };
    TextActionComponent.prototype.getNewTextMessagePlaceholder = function () {
        if (!this.authorizedKeys[this.selectedType]) {
            var alternateView = this.selectedType === this.authorizationKeys.SendTextSales ? this.translations.text_service : this.translations.text_sales;
            return this.translateService.instant('text_switch_conversation', { viewType: alternateView });
        }
        else {
            return this.translateService.instant('enterTextMessage');
        }
    };
    TextActionComponent.prototype.openDialog = function () {
        var _this = this;
        if (this.shouldDisableTextAction()) {
            this.logger.warning(this.tooltip);
            return;
        }
        var validateUserNumberAndOpenDialog = function () {
            _this.textMessageService.isUserNumberTextable()
                .subscribe(function (isTextable) {
                if (!isTextable) {
                    var noUserNumberModal = jquery_1.default(_this.noUserNumberModal);
                    noUserNumberModal.modal({ show: true, backdrop: true });
                    noUserNumberModal.appendTo('body');
                    noUserNumberModal.on('hidden.bs.modal', function () { return _this.handleStackedDialogClose(); });
                    return;
                }
                else {
                    _this.openTextingDialog();
                }
            });
        };
        if (this.opportunity.customer.doNotText) {
            this.logger.warning('Customer has requested not to be sent any texts.');
            return;
        }
        if (!this.opportunity.customer.cellPhoneNumber ||
            !this.opportunity.customer.cellPhoneNumber.value ||
            !(this.opportunity.customer.cellPhoneNumber.value.length > 0) ||
            this.opportunity.customer.cellPhoneNumber.isBad) {
            this.logger.warning(this.translateService.instant('textMessageNoCustomerCellNumber'));
            return;
        }
        if (this.textableStatus.eulaStatus &&
            this.textableStatus.eulaStatus !== this.eulaStatusTypes.fullyAccepted) {
            this.eulaModalService.validateEula()
                .then(function (result) {
                if (!result) {
                    _this.logger.warning('caslNotAccepted');
                    return;
                }
                validateUserNumberAndOpenDialog();
            });
        }
        else {
            validateUserNumberAndOpenDialog();
        }
    };
    TextActionComponent.prototype.continueUserNumberConfirmation = function () {
        this.openTextingDialog();
    };
    TextActionComponent.prototype.openTextingDialog = function () {
        var _this = this;
        this.textMessages = [];
        this.filteredMessages = [];
        if (this.modalClosedSubject && !this.modalClosedSubject.isStopped) {
            this.modalClosedSubject.next(true);
            this.modalClosedSubject.unsubscribe();
        }
        this.modalClosedSubject = new rxjs_1.Subject();
        this.busy = this.getMessageHistory()
            .subscribe(function () {
            jquery_1.default(_this.textModalSelector).modal({ show: true, backdrop: true });
            // Bootstrap recommends that all of their modals be appended to the top level of the body
            // (see https://getbootstrap.com/docs/3.3/javascript/#modals)
            // Here I am using jquery to move my component modal html to the body tag. In ngOnDestroy I remove it from the body tag
            //$(this.textModalSelector).appendTo('body');
            //const modalBackdrop = this.document.querySelector('.modal-backdrop.in');
            //this.originalBackdropZindex = modalBackdrop.style['z-index'];
            //modalBackdrop.style['z-index'] = this.nestedModalBackdropZindex;
        });
        this.subscriptionAggregator.add(this.busy);
        this.notificationSubscription = this.notificationService.message$.subscribe(function (message) {
            _this.handleNotification(message);
        });
        this.subscriptionAggregator.add(this.notificationSubscription);
        jquery_1.default(this.textModalSelector).on('hidden.bs.modal', function () { return _this.handleModalClosed(); });
    };
    TextActionComponent.prototype.shouldDisplayDateLine = function (currentTextMessageIndex) {
        if (currentTextMessageIndex === 0) {
            return true;
        }
        var currentMessageSentDate = moment_1.default(this.filteredMessages[currentTextMessageIndex].sentDateTime);
        var prevousMessageSentDate = this.filteredMessages[currentTextMessageIndex - 1].sentDateTime;
        return moment_1.default(currentMessageSentDate).isAfter(prevousMessageSentDate, 'day');
    };
    TextActionComponent.prototype.shouldDisplayUpgradeProposalLink = function () {
        return (this.opportunity && this.opportunity.currentContract && this.opportunity.currentContract.saleType !== this.saleTypes.balloon);
    };
    TextActionComponent.prototype.getDisplayDate = function (date) {
        if (moment_1.default(new Date(date)).isSame(new Date(), 'day')) {
            return 'Today';
        }
        if (moment_1.default(new Date(date)).isSame(moment_1.default(new Date()).subtract(1, 'day'), 'day')) {
            return 'Yesterday';
        }
        return new Date(date).toLocaleDateString(this.cultureName, { year: 'numeric', month: 'long', day: 'numeric' });
    };
    TextActionComponent.prototype.getMessageFooter = function (message) {
        if (!message) {
            throw new Error('No message passed to getMessageFooter in TextActionComponent');
        }
        var formattedTime = new Date(message.sentDateTime).toLocaleTimeString(this.cultureName, { hour: 'numeric', minute: 'numeric' });
        // If its from us and its not from the current user then display the name of the user who sent it
        var userName = (message.outgoing &&
            message.userId !== this.userProfile.userId) ? message.userFirstName + " " + message.userLastName + " - " : '';
        return "" + userName + formattedTime;
    };
    TextActionComponent.prototype.sendMessage = function (message) {
        // TODO need a way to get user avatar if this is the first message
        var _this = this;
        if (!message || message.trim() === '') {
            return;
        }
        var newMessage = {};
        newMessage = {
            userAvatarUrl: null,
            customerId: this.opportunity.customer.id,
            entityId: this.opportunity.id,
            userFirstName: this.userProfile.firstName,
            userLastName: this.userProfile.lastName,
            message: message,
            cleanedMessage: message,
            sentDateTime: new Date().toISOString(),
            userId: this.userProfile.userId,
            messageId: -1,
            dealerId: this.opportunity.dealerId,
            accountSid: '',
            smsSid: '',
            customerPhone: this.opportunity.customer.cellPhoneNumber.value,
            outgoing: true,
            displayDate: this.getDisplayDate(new Date().toISOString()),
            messageFooter: '',
            customerFirstName: '',
            customerLastName: '',
            activityId: -1,
            isTextable: true,
            dealerPhoneAccessRightID: this.selectedType,
            hasUpgradeProposalLink: false
        };
        newMessage.messageFooter = this.getMessageFooter(newMessage);
        if (message.indexOf(this.upgradeProosalLinkPlaceholder) > 0) {
            newMessage.hasUpgradeProposalLink = true;
            this.busy = this.textMessageService.sendTextWithUpgradeProposal(__assign({}, newMessage), this.opportunity)
                .subscribe(function (response) {
                response.textResponse.activityId = response.proposalResponse.activityId;
                _this.handleSendMessageResponse(newMessage, response.textResponse);
            });
        }
        else {
            this.busy = this.textMessageService.sendText(__assign({}, newMessage))
                .subscribe(function (textMessage) {
                _this.handleSendMessageResponse(newMessage, textMessage);
            });
        }
    };
    TextActionComponent.prototype.handleSendMessageResponse = function (messageRequest, messageResponse) {
        if (!messageResponse.isTextable) {
            this.logger.warning(this.translateService.instant('textMessageCustomerStatusMayHaveChanged'));
            jquery_1.default(this.textModalSelector).modal('hide');
            this.refreshTextableStatus();
            return;
        }
        var newMessageResponse = messageRequest;
        newMessageResponse.message = messageResponse.message.replace(/\n\r?/g, '<br />');
        if (messageResponse.activityId > 0) {
            var cleanedMessage = text_message_service_1.TextMessageService.replaceUrlStringWithHtmlLink(messageResponse.message, true);
            newMessageResponse.cleanedMessage = this.domSanitizer.bypassSecurityTrustHtml(cleanedMessage);
        }
        newMessageResponse.activityId = messageResponse.activityId;
        newMessageResponse.messageFooter = messageRequest.messageFooter;
        newMessageResponse.displayDate = messageRequest.displayDate;
        newMessageResponse.isTextable = messageResponse.isTextable;
        newMessageResponse.messageId = messageResponse.messageId;
        newMessageResponse.dealerPhoneAccessRightID = messageResponse.dealerPhoneAccessRightID;
        this.textMessages.push(newMessageResponse);
        this.filterMessages();
        this.newTextMessageValue = '';
    };
    TextActionComponent.prototype.getMaxRows = function (currentMessage) {
        var maxRows = 10;
        var columns = 60;
        var arrayOfLines = currentMessage.split('\n');
        var rows = arrayOfLines.length;
        for (var i = 0; i < arrayOfLines.length; i++) {
            rows += Math.floor((arrayOfLines[i].length / columns));
            if (rows < 2) {
                rows = 2;
            }
        }
        return (rows > maxRows) ? maxRows : rows;
    };
    TextActionComponent.prototype.timeSpanChanged = function (timeSpanToDisplay) {
        this.timeSpanToDisplay = timeSpanToDisplay;
        this.filterMessages();
    };
    TextActionComponent.prototype.toggleSalesServiceSelection = function (type) {
        this.selectedType = type;
        this.filterMessages();
    };
    TextActionComponent.prototype.getMessageHistory = function () {
        var _this = this;
        return this.textMessageService.getHistory(this.opportunity)
            .pipe(operators_1.map(function (messages) {
            _this.textMessages = _this.mapServiceResults(messages);
            _this.filterMessages();
        }));
    };
    TextActionComponent.prototype.refreshTextableStatus = function () {
        var _this = this;
        if (this.opportunity) {
            var sub = this.textMessageService.getTextableStatus(this.opportunity.customer, this.opportunity.dealerId)
                .subscribe(function (textableStatus) {
                _this.updateTextableStatus(textableStatus);
            });
            this.subscriptionAggregator.add(sub);
        }
    };
    TextActionComponent.prototype.updateTextableStatus = function (textableStatus) {
        var _this = this;
        this.tooltip = '';
        this.isTextable = textableStatus.isTextable;
        this.textableStatus = textableStatus;
        if (textableStatus.employeeUserCannotTextCustomer) {
            this.tooltip = this.translateService.instant(this.employeeUserTextingUnavailableTranslationKey);
            this.changeDetectorRef.detectChanges();
            return;
        }
        if (!this.isDealerTextingEnabled()) {
            this.tooltip = this.translateService.instant(this.storeTextingUnavailableTranslationKey);
            this.changeDetectorRef.detectChanges();
            return;
        }
        var appendToTooltip = function (toolTipTranslationKey, substitutionOptions) {
            var toolTipLineBreak = '\u000A';
            if (_this.tooltip.length > 0) {
                _this.tooltip += toolTipLineBreak;
            }
            _this.tooltip = _this.translateService.instant(toolTipTranslationKey, substitutionOptions);
        };
        if (!this.hasTextingPermission() && this.hasProvisionedDealerNumbers()) {
            this.tooltip = this.translateService.instant(this.userTextingUnavailableTranslationKey);
            this.changeDetectorRef.detectChanges();
            return;
        }
        if (textableStatus.isTextable) {
            if (textableStatus.consentDateTime) {
                appendToTooltip('textMessageOptInStatus', { consentDateTime: this.localeDateTimePipe.transform(textableStatus.consentDateTime) });
            }
            else {
                if (textableStatus.hasValidTouchpoint) {
                    appendToTooltip('textMessageHasValidTouchpoint', { touchpointDate: this.localeDateTimePipe.transform(textableStatus.touchpointDate) });
                }
                else {
                    appendToTooltip('textMessageDealerNumberProvisionedTooltip', { dealerNumberProvisionedDate: this.localeDateTimePipe.transform(textableStatus.dealerNumberProvisionedDate) });
                }
            }
        }
        else {
            if (textableStatus.consentNotGranted) {
                // This will be null if they opted out so specifically checking for false here
                if (textableStatus.hasValidTouchpoint === false) {
                    appendToTooltip('textMessageCustomerHasNotConsented');
                }
                else {
                    appendToTooltip('textMessageCustomerOptOutTooltip', { consentDateTime: this.localeDateTimePipe.transform(textableStatus.consentDateTime) });
                }
            }
            else {
                if (!textableStatus.hasContactInfo) {
                    appendToTooltip('textMessageNoContactInfo');
                }
                if (textableStatus.noCustomerCellNumber) {
                    appendToTooltip('textMessageNoCustomerCellNumber');
                }
                else if (textableStatus.invalidCustomerNumber) {
                    appendToTooltip('textMessageNumberInvalidTooltip');
                }
            }
            if (textableStatus.outsideTextingHours) {
                appendToTooltip('textMessageBusinessHoursTooltip');
            }
            if (this.tooltip.length === 0) {
                appendToTooltip('textNumbersNotProvisioned');
            }
        }
        this.changeDetectorRef.detectChanges();
    };
    TextActionComponent.prototype.isDealerTextingEnabled = function () {
        return !(this.textableStatus && this.textableStatus.dealerTextingEnabled === false);
    };
    TextActionComponent.prototype.shouldDisableTextAction = function () {
        return !this.isDealerTextingEnabled() || !this.isTextable || !this.hasTextingPermission();
    };
    TextActionComponent.prototype.hasTextingPermission = function () {
        return !!(this.authorizedKeys[this.authorizationKeys.SendTextSales] || this.authorizedKeys[this.authorizationKeys.SendTextService]);
    };
    TextActionComponent.prototype.hasProvisionedDealerNumbers = function () {
        return !!(this.textableStatus && this.textableStatus.dealerNumberProvisionedDate);
    };
    TextActionComponent.prototype.handleModalClosed = function () {
        if (!this.modalClosedSubject.isStopped) {
            this.modalClosedSubject.next(true);
            this.modalClosedSubject.unsubscribe();
        }
        this.notificationSubscription.unsubscribe();
        this.handleStackedDialogClose();
    };
    TextActionComponent.prototype.handleStackedDialogClose = function () {
        // Hack because closing a stacked modal removes the modal-open class from all open modals
        // Components should not be modifying dom outside of themselves this is a hack
        if (document.querySelector('body > .modal')) {
            document.body.classList.add('modal-open');
        }
        var modalBackdrop = this.document.querySelector('.modal-backdrop.in');
        if (modalBackdrop) {
            modalBackdrop.style['z-index'] = this.originalBackdropZindex;
        }
    };
    TextActionComponent.prototype.mapServiceResults = function (messages) {
        var _this = this;
        var textMessages = messages;
        textMessages.forEach(function (m) {
            m.displayDate = _this.getDisplayDate(m.sentDateTime);
            m.messageFooter = _this.getMessageFooter(m);
            m.cleanedMessage = m.message;
            // Limit skipping sanitization for only outgoing messages.
            if (m.outgoing) {
                m.cleanedMessage = _this.domSanitizer.bypassSecurityTrustHtml(text_message_service_1.TextMessageService.replaceUrlStringWithHtmlLink(m.message, true));
            }
        });
        return textMessages;
    };
    TextActionComponent.prototype.filterMessages = function () {
        var _this = this;
        if (!this.textMessages || this.textMessages.length === 0) {
            return;
        }
        var fromDate = this.getFromDateFromTimespan();
        this.filteredMessagesModified = true;
        this.filteredMessages = this.textMessages.filter(function (message) {
            return moment_1.default(message.sentDateTime).isAfter(fromDate) && message.dealerPhoneAccessRightID === _this.selectedType;
        });
    };
    TextActionComponent.prototype.getFromDateFromTimespan = function () {
        switch (this.timeSpanToDisplay) {
            case this.lastMonth:
                return moment_1.default().subtract(30, 'day').toDate();
            case this.last6Months:
                return moment_1.default().subtract(180, 'day').toDate();
            case this.lastYear:
                return moment_1.default().subtract(365, 'day').toDate();
            case this.allTexts:
                return new Date(1900, 1, 1);
        }
    };
    return TextActionComponent;
}());
exports.TextActionComponent = TextActionComponent;
